import React, { useContext, useEffect, useState } from "react";
import { CartContextStart } from "../Context/CartContext";

export default function SlideInCartItem(props) {

  const { cartItems, setCartItems } = useContext(CartContextStart);

  const [cartItemQuantity, setCartItemQuantity] = useState(props.cartItemQuantity);

  const incrementCartItemQuantity = () => {
    setCartItemQuantity(cartItemQuantity + 1);
  }

  const decrementCartItemQuantity = () => {
    setCartItemQuantity(cartItemQuantity > 1 ? cartItemQuantity - 1 : cartItemQuantity);
  }

  useEffect(() => {
    setCartItems(cartItems.filter((singleItem) => {
      return singleItem.getProductData.pid === props.cartItemProductId ? singleItem.itemQuantity = cartItemQuantity : singleItem.itemQuantity;
    }))
  }, [cartItemQuantity])

  return (
    <>
      {/* Cart Item Start */}
      <div className="cart-item mb-4 pb-3 d-flex justify-content-between">
        <div className="cart-item-details d-flex gap-3">
          <div className="cart-item-img d-flex align-items-center">
            <img src={props.cartItemImg} alt="cart-item" />
          </div>
          <div className="cart-item-nameCounter">
            <p className="cart-item-name mb-2">{props.cartItemTitle}</p>
            <div className="cart-item-counter">
              <button onClick={decrementCartItemQuantity}>-</button>
              <button className="cart-item-counter-value">{cartItemQuantity}</button>
              <button onClick={incrementCartItemQuantity}>+</button>
            </div>
          </div>
        </div>
        <div className="cart-item-price-cover">
          <p
            onClick={() => {
              setCartItems(
                cartItems.filter((singleItem) => {
                  return singleItem.getProductData.pid !== props.cartItemProductId;
                })
              )
            }}
            className="ms-auto cart-item-del-btn mx-0 mb-2 p-0 d-flex justify-content-center align-items-center"
          >
            <i className="fa-solid fa-x"></i>
          </p>
          <p className="ms-auto p-0 pt-1 cart-item-price">£{props.cartItemPrice * cartItemQuantity}</p>
        </div>
      </div>
      {/* Cart Item End */}
    </>
  );
}
